import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  CreateTaskDto,
  TaskItem,
  TaskPageResult,
  TaskQueryParams,
  TaskSummaryResult,
  UpdateTaskDto,
} from './types/task';

const request = createAppRequest();
const BASE_PATH = '/bff/zy-crm/tasks';

export async function queryTasks(params: TaskQueryParams, options?: ApiRequestOptions) {
  return request<TaskPageResult>(BASE_PATH, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function queryTaskSummary(options?: ApiRequestOptions) {
  return request<TaskSummaryResult>(`${BASE_PATH}/summary`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getTaskDetail(uuid: string, options?: ApiRequestOptions) {
  return request<TaskItem>(`${BASE_PATH}/${uuid}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function createTask(payload: CreateTaskDto, options?: ApiRequestOptions) {
  return request<TaskItem>(BASE_PATH, {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function updateTask(uuid: string, payload: UpdateTaskDto, options?: ApiRequestOptions) {
  return request<TaskItem>(`${BASE_PATH}/${uuid}`, {
    method: 'PATCH',
    data: payload,
    ...(options || {}),
  });
}

export async function deleteTask(uuid: string, options?: ApiRequestOptions) {
  return request<void>(`${BASE_PATH}/${uuid}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}
